import React, { useState, useEffect } from "react";
import { Link , useNavigate} from "react-router-dom";
import config from '../config';

export default function Product() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${config.baseURL}/categoriesfront`);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryId) => {
    navigate(`/products/${categoryId}`);
  };

  const handleCategoryClick1 = (categoryId) => {
    navigate(`/products2/${categoryId}`);
  };

  return (
    <div className="relative isolate px-6 py-14 lg:px-8">
      <div className="mx-auto max-w-100">
        <div className="text-center">
          {/* <div className="flex mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8"> */}
          <div className="flex mx-2px max-w-2xl px-6 lg:max-w-7xl lg:px-8 ">
            <div className=" flex flex-wrap gap-4 items-center">
              {categories.map((category) => (
                <div
                  key={category.id}
                  className="cursor-pointer w-[40%]" // Adjust width to maintain 3 cards per row
                  onClick={() => handleCategoryClick1(category.id)}
                >
                  <img
                    src={`${config.imageURL}/uploads/${category.image}`}
                    alt={category.catname}
                    className="w-full aspect-[4/3] object-cover border-2 border-gray-300 rounded-md shadow-md"
                  />
                  <p className="mt-2 text-lg font-medium text-gray-950">
                    {category.catname}
                  </p>
                  <p className="mt-1 text-gray-700"> 
                    {category.details}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
